import initial from "./initial";
import { Map, List, fromJS } from "immutable";
import { SWITCHONAUDIO } from "./actions";
import { MIDIACCESS } from "./actions";
import { SETMIDIDEVICESLOOPER } from "./actions";
import { UPDATEPOOL } from "./actions";
import { UPDATEBOUNCE } from "./actions";
import { SQUAREONMOUSEDOWN } from "./actions";
import { SQUAREONMOUSEUP } from "./actions";
import { SQUAREONMOUSEOVER } from "./actions";
import { DIALONMOUSEMOVE } from "./actions";
import { DIALONMOUSEDOWN } from "./actions";
import { SHOWMENU } from "./actions";
import { BALL } from "./actions";
import { ANIMATIONID } from "./actions";
import { TRANSPOSETONES } from "./actions";
import { CUECHORD } from "./actions";
import { CLEAR } from "./actions";
import { LOOPERONCLICKBUTTON } from "./actions";
import { LOOPERONCLICKFADER } from "./actions";
import { LOOPERONCLICKMUTE } from "./actions";
import { BasicFm } from '../synths/class-basic-fm';
import { audioContext } from '../synths/audio-setup';
import { outputDry } from '../synths/audio-setup';
import { outputWet } from '../synths/audio-setup';
import { scaleNumbers } from '../utilities';

const switchOnAudio = (state) => {
	audioContext.resume();
	return state.set('audioIsAllowed', true);
}

const showMenu = (state, {bool}) => {
    return state.set('menuIsVisible', bool);
}

const midiAccess = (state, {WebMidi}) => {
	let inputs = WebMidi.inputs;
	let outputs = WebMidi.outputs;
	// update all devices that use midi
	let loopers = state.get('loopers');
	loopers = loopers.map((looper) => looper.set('midiInDevice', inputs[0]));
	loopers = loopers.map((looper) => looper.set('midiOutDevice', outputs[0]));
	return state.setIn(['midi', 'midiAccess'], true)
				.setIn(['midi', 'inputs'], inputs)
				.setIn(['midi', 'outputs'], outputs)
				.setIn(['midi', 'WebMidi'], WebMidi)
				.set('loopers', loopers);
}

const setMidiDevicesLooper = (state, {i, isInput}) => {
	let loopers = state.get('loopers');
	loopers = loopers.map((looper) => {
		return isInput ? looper.set('midiInDevice', state.getIn(['midi', 'inputs'])[i]) : looper.set('midiOutDevice', state.getIn(['midi', 'outputs'])[i]);
	})
	return state.set('loopers', loopers);
}

const updatePool = (state) => {
	let poolInfo = document.getElementById("pool") && document.getElementById("pool").getBoundingClientRect();
	return state.setIn(['pool', 'poolInfo'], fromJS(poolInfo));
}

const updateBounce = (state) => {
	let bounceInfo = document.getElementById("bounce") && document.getElementById("bounce").getBoundingClientRect();
	return state.setIn(['bounce', 'bounceInfo'], fromJS(bounceInfo));
}

const createRipple = (state, event) => {
	let pool = state.getIn(['pool', 'poolInfo']);
	let ripples = state.getIn(['pool', 'ripples']);
	ripples = removeOldRipplesNodes(ripples);
	return ripples.push(
		Map({ 
			height: 100,
			width: 100,
			x: (event.clientX) - 50 - pool.x,
			y: (event.clientY) - 50 - pool.y, 
			timestamp: Math.floor(Date.now()),
			rippleSize: scaleNumbers(1, pool.width, 1, 4, event.clientX), // depends on x axis
		})
	);
}

const removeOldRipplesNodes = (ripples) => (
	ripples.filter((ripple) => Math.floor(Date.now()) - ripple.get('timestamp') < 10000 )
)

const squareOnMouseDown = (state, {event, i, isHeld=true}) => {
	playNotePool(state, event, i);
	return state.setIn(['pool', 'ripples'], createRipple(state, event))
				.setIn(['pool', 'mouseDown'], isHeld);
}
const squareOnMouseOver = (state, {event, i}) => {
	if (state.getIn(['pool', 'mouseDown'])) {
		playNotePool(state, event, i);
		return state.setIn(['pool', 'ripples'], createRipple(state, event));
	} 
	return state;
}

const squareOnMouseUp = (state) => state.setIn(['pool', 'mouseDown'], false);

const playNotePool = (state, event, i) => {
	let row = getRowFromId(i, 10);
	let pool = state.getIn(['pool', 'poolInfo']);
	let noteVol = scaleNumbers(1, pool.width, 20, 80, event.clientX);
	let tone = state.getIn(['scale', row]);
	let synth = createSynth(state.get('synth').toJS(), state.get('controls'));
	synth.play(tone, noteVol);
}

const getRowFromId = (id, numCols) => {
	return Math.floor(id/numCols);
}

const createSynth = (synthState, synthControls) => {
	let synth = new BasicFm(audioContext);
	synth.connectTo( outputDry, true ); // true - disconnect from main destination first
	synth.connectTo( outputWet, false ); // false - connect to and wet and keep connection with dry
	synth.setRatio(
		Math.ceil(scaleNumbers(0, 127, 0, 12, synthControls.getIn([1, 'value']))), 
		Math.ceil(scaleNumbers(0, 127, 0, 12, synthControls.getIn([2, 'value']))), 
	);
	synth.setModAmp(
		scaleNumbers(0, 127, 1, 20, synthControls.getIn([3, 'value']))
	);
	synth.setCarrEnv(synthState.a, synthState.d, synthState.s, synthState.r, synthState.sLevel);
	synth.setModEnv(synthState.aMod, synthState.dMod, synthState.sMod, synthState.rMod, synthState.sLevelMod);
	synth.setVol(scaleNumbers(0, 127, 0, 1, synthControls.getIn([0, 'value'])));
	return synth;
}

const dialOnMouseDown = (state, {i, bool}) => state.setIn(['controls', i, 'mouseDown'], bool);

const dialOnMouseMove = (state, {event, i}) => {
	let dial = document.getElementById(`dial_${i}`).getBoundingClientRect();
	let newValue = Math.floor(127 - (event.clientY - dial.y) * (127/dial.height));
	return state.getIn(['controls', i, 'mouseDown']) ? state.setIn(['controls', i, 'value'], newValue) : state;
}

const createBall = (state, {event, r}) => {
	let balls = state.getIn(['bounce', 'balls']);
	let newBall = Map({
		cx: event.clientX,
		cy: event.clientY,
		dy: 0,
		r: r,
		opacity: 0.1,
		height: event.clientY,
		inMotion: true,
	});
	return state.setIn(['bounce', 'balls'], balls.push(newBall));
}

const animateBalls = (state, {animationID}) => {
	let bounce = state.get('bounce').toJS();
	let balls = bounce.balls;
	let bounceInfo = state.getIn(['bounce', 'bounceInfo']);
	for (var i = 0; i < balls.length; i++) {
		if (bounceInfo.height - balls[i].height > balls[i].r + 0.1) {
			if (balls[i].cy + balls[i].r > bounceInfo.height) {
	            balls[i].dy = -(Math.abs(balls[i].dy) * bounce.friction);
	            balls[i].opacity = 1;
	            // stop playing the note when it runs out of energy
	            (bounceInfo.height - balls[i].height > balls[i].r + 2) && playNoteBounce(state, i);
	    	} else {
	            if(balls[i].opacity > 0.2) balls[i].opacity -= (1/240);
	    		balls[i].dy += bounce.speed;
	    	}
	    	// at top of bounce update ball height
	    	if(balls[i].dy > 0 && balls[i].dy < 0.1) balls[i].height = balls[i].cy;
	    	balls[i].cy += balls[i].dy; 
		} else {
			balls[i].opacity -= (1/120);
		}
	}
	bounce.balls = balls.filter((ball) => ball.opacity > 0);
	bounce.animationID = animationID;
	return state.set('bounce', fromJS(bounce));
}

const playNoteBounce = (state, ballID) => {
	let ball = state.getIn(['bounce', 'balls', ballID]);
	let bounce = state.getIn(['bounce', 'bounceInfo']);
	let toneNum = Math.floor(scaleNumbers(0, bounce.width, 0, state.get('scale').size, ball.get('cx')));
    let tone = state.getIn(['scale', toneNum]);
    let noteVol = scaleNumbers(0, (bounce.height * 10), 0, 127, (bounce.height - ball.get('height')) * (ball.get('r') / 10) );
	let synth = createSynth(state.get('synth').toJS(), state.get('controls'));
	synth.play(tone, noteVol);
}

const transposeTones = (state, {i}) => {
	let cuedScale = state.get('tones').filter((chord) => chord.get('chord') === state.get('cuedScale'));
	let transposedScale = cuedScale.getIn([0, 'tones']).map(tone => tone + i);
	return state.set('scale', transposedScale);
}

const cueChord = (state, {i}) => {
    return state.set('scale', state.getIn(['tones', i, 'tones']))
                .set('cuedScale', state.getIn(['tones', i, 'chord']));
}

const clear = (state) => {
	return state.setIn(['pool', 'ripples'], List([]))
				.setIn(['bounce', 'balls'], List([]));
}


/* --------------------------------------------------------------
LOOPERS
-------------------------------------------------------------- */

// use switch to map different buttons presses to actions. Can be swapped out for supercollider if needed.

const looperOnClickButton = (state, {id, loopr}) => {
	let looper = state.getIn(['loopers', loopr]);
	let ctrlMessage = [];
	// what about if - press pause whilst recording, press trigger whilst paused etc.
	let buttons = looper.get('buttons');
	let isRecording = buttons.getIn(['record', 'status']) % 2 !== 0;
	if (isRecording && id === 0) {
		buttons = setRecordButtons(buttons); 
		ctrlMessage = sendControlMessage(looper, 0, buttons.getIn(['record', 'status']));
	}
	if (!isRecording) {
		switch (id) {
			case 0: 
				buttons = setRecordButtons(buttons); 
				buttons.get('record');
				ctrlMessage = sendControlMessage(looper, buttons.getIn(['record', 'ctrlNum']), buttons.getIn(['record', 'status']));
				break;
			case 1: 
				buttons = setPlayButtons(buttons);
				buttons.get('play');
				ctrlMessage = sendControlMessage(looper, buttons.getIn(['play', 'ctrlNum']), buttons.getIn(['play', 'status']));
				break;
			case 2:
				buttons = setPlayButtons(buttons, false);
				buttons.get('trigger');
				ctrlMessage = sendControlMessage(looper, buttons.getIn(['trigger', 'ctrlNum']), 1); // trigger from start
				break;
			case 3:
				buttons = setOctaveButtons(buttons);
				buttons.get('octave');
				ctrlMessage = sendControlMessage(looper, buttons.getIn(['octave', 'ctrlNum']), buttons.getIn(['octave', 'status']));
				break;
			case 4:
				buttons = setFadeIn(buttons);
				buttons.get('fadeIn');
				ctrlMessage = sendControlMessage(looper, buttons.getIn(['fadeIn', 'ctrlNum']), buttons.getIn(['fadeIn', 'status']));
				break;
			case 5:
				buttons = setFadeOut(buttons);
				buttons.get('fadeOut');
				ctrlMessage = sendControlMessage(looper, buttons.getIn(['fadeOut', 'ctrlNum']), buttons.getIn(['fadeOut', 'status']));
				break;
			case 6:
				buttons = setClear(buttons);
				buttons.get('clear');
				ctrlMessage = sendControlMessage(looper, buttons.getIn(['clear', 'ctrlNum']), buttons.getIn(['clear', 'status']));
				break;
			default:
				return buttons;
		}
	}
	return state.setIn(['loopers', loopr, 'buttons'], buttons)
				.setIn(['midi', 'ctrlMessage'], ctrlMessage);
}

const sendControlMessage = (component, ctrlNum, value) => {
	let output = component.get('midiOutDevice');
	let channel = component.get('midiChannel');
	if(output) output.sendControlChange(ctrlNum, value, channel);
	return [ctrlNum, value, channel];
}
	

const setRecordButtons = (buttons) => {
	let recordColours = ['#CF6766', '#E1332D', '#D8C3A5', '#E1332D'];
	let recordActions = ['record', 'recording', 'overdub', 'recording'];
	let colours = ['#8E8D8A', '#CF6766'];
	let status = buttons.getIn(['record', 'status']);
	status < 3 ? status++ : status--;
	return buttons.setIn(['record', 'status'], status)
				  .setIn(['record', 'colour'], recordColours[status])
				  .setIn(['record', 'action'], recordActions[status])
				  .setIn(['clear', 'status'], 0)
				  .setIn(['clear', 'colour'], colours[0])
}

const setPlayButtons = (buttons, toggle=true) => {
	let playColours = ['#4EA699', '#D8C3A5'];
	let playActions = ['play', 'pause'];
	let status = buttons.getIn(['play', 'status']);
	if (!toggle) {
		status = 1;
	} else {
		status ? status-- : status++;
	}

	return buttons.setIn(['play', 'status'], status)
				  .setIn(['play', 'colour'], playColours[status])
				  .setIn(['play', 'action'], playActions[status]);
}

const setOctaveButtons = (buttons) => {
	let colours = ['#8E8D8A', '#D8C3A5'];
	let actions = ['-8ve', '+8ve'];
	let status = buttons.getIn(['octave', 'status']);
	status ? status-- : status++;
	return buttons.setIn(['octave', 'status'], status)
				  .setIn(['octave', 'colour'], colours[status])
				  .setIn(['octave', 'action'], actions[status]);
}

const setFadeIn = (buttons) => {
	let colours = ['#8E8D8A', '#4EA699'];
	let status = buttons.getIn(['fadeIn', 'status']);
	status ? status-- : status++;
	return buttons.setIn(['fadeIn', 'status'], status)
				  .setIn(['fadeIn', 'colour'], colours[status]);
}

const setFadeOut = (buttons) => {
	let colours = ['#8E8D8A', '#4EA699'];
	let status = buttons.getIn(['fadeOut', 'status']);
	status ? status-- : status++;
	return buttons.setIn(['fadeOut', 'status'], status)
				  .setIn(['fadeOut', 'colour'], colours[status]);
}

const setClear = (buttons) => {
	let recordColours = ['#CF6766', '#E1332D', '#D8C3A5', '#E1332D'];
	let recordActions = ['record', 'recording', 'overdub', 'recording'];
	let colours = ['#8E8D8A', '#CF6766'];
	let status = buttons.getIn(['clear', 'status']);
	status ? status-- : status++;
	return buttons.setIn(['clear', 'status'], status)
				  .setIn(['clear', 'colour'], colours[status])
				  .setIn(['record', 'status'], 0)
				  .setIn(['record', 'colour'], recordColours[0])
				  .setIn(['record', 'action'], recordActions[0]);

}

const looperOnClickFader = (state, {e, id, loopr}) => {
	let looper = state.getIn(['loopers', loopr]);
	let ctrlNum = looper.getIn(['faders', id, 'ctrlNum']);
	let fader = e.target.getBoundingClientRect();
	let clicked = e.clientY - fader.y;
	let value = Math.floor(scaleNumbers(0, fader.height, 127, 0, clicked));
	let ctrlMessage = sendControlMessage(looper, ctrlNum, value);
	return state.setIn(['loopers', loopr, 'faders', id, 'value'], value)
				.setIn(['midi', 'ctrlMessage'], ctrlMessage);
}

const looperOnClickMute = (state, {id, loopr}) => {
	let looper = state.getIn(['loopers', loopr]);
	let ctrlNum = looper.getIn(['faders', id, 'ctrlNum']);
	let mute = state.getIn(['loopers', loopr, 'faders', id, 'mute']);
	let value = !mute ? 0 : looper.getIn(['faders', id, 'value']);
	let ctrlMessage = sendControlMessage(looper, ctrlNum, value);
	return state.setIn(['loopers', loopr, 'faders', id, 'mute'], !mute)
				.setIn(['midi', 'ctrlMessage'], ctrlMessage);
}

export default (state = initial, action) => {
	switch (action.type) {
		case SWITCHONAUDIO: return switchOnAudio(state);
		case SHOWMENU: return showMenu(state, action);
		case MIDIACCESS: return midiAccess(state, action);
		case SETMIDIDEVICESLOOPER: return setMidiDevicesLooper(state, action);
		case UPDATEPOOL: return updatePool(state);
		case UPDATEBOUNCE: return updateBounce(state);
		case SQUAREONMOUSEDOWN: return squareOnMouseDown(state, action);
		case SQUAREONMOUSEUP: return squareOnMouseUp(state);
		case SQUAREONMOUSEOVER: return squareOnMouseOver(state, action);
		case DIALONMOUSEMOVE: return dialOnMouseMove(state, action);
		case DIALONMOUSEDOWN: return dialOnMouseDown(state, action);
		case BALL: return createBall(state, action);
		case ANIMATIONID: return animateBalls(state, action);
		case TRANSPOSETONES: return transposeTones(state, action);
		case CUECHORD: return cueChord(state, action);
		case CLEAR: return clear(state);
		case LOOPERONCLICKBUTTON: return looperOnClickButton(state, action);
		case LOOPERONCLICKFADER: return looperOnClickFader(state, action);
		case LOOPERONCLICKMUTE: return looperOnClickMute(state, action);
		default: return state;
	}
};


// WEBPACK FOOTER //
// ./src/data/reducer.js